import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import type { UseOutstandingBalanceResult } from '@hooks/dashboard/useOutstandingBalance'
import {
  formatCurrency,
  HYGIENE_PLACEHOLDER,
} from '@utils/dashboardFinance.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import { dashboardFinanceMetricFooter } from '../shared/dashboardFinanceMetricFooter'
import { FinanceMetricTileGrid } from '../../FinanceMetricTiles.component'

type OutstandingBalanceCardProps = {
  titleHref: string
  outstanding: UseOutstandingBalanceResult
}

export function OutstandingBalanceCard({
  titleHref,
  outstanding,
}: OutstandingBalanceCardProps): React.ReactElement {
  const { loading, totals, hasData, hasPayload } = outstanding

  const metricItems = totals
    ? [
        {
          leftLabel: 'Total balance',
          value: formatCurrency(totals.totalBalance.current, {
            compact: true,
          }),
          footer: dashboardFinanceMetricFooter(totals.totalBalance),
        },
        {
          leftLabel: 'Total charges',
          value: formatCurrency(totals.totalCharges.current, {
            compact: true,
          }),
          footer: dashboardFinanceMetricFooter(totals.totalCharges),
        },
      ]
    : loading
      ? [
          { leftLabel: 'Total balance', value: HYGIENE_PLACEHOLDER },
          { leftLabel: 'Total charges', value: HYGIENE_PLACEHOLDER },
        ]
      : []

  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasData)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="Outstanding balance"
      titleHref={titleHref}
      className="dashboard-finance-outstanding-card"
      loading={pending}
      skeleton={{ metrics: 2, block: 'none' }}
      isEmpty={isEmpty}
      disableTitleLink={isEmpty}
    >
      <div className="dashboard-finance-outstanding-wrap">
        {metricItems.length > 0 ? (
          <FinanceMetricTileGrid columns={2} items={metricItems} />
        ) : null}
      </div>
    </DashboardSectionCard>
  )
}
